
import React, { useState } from "react";
import {
  auth,
  createUserWithEmailAndPassword,
  setDoc, userDoc
} from "../firebase";
import { useNavigate, Link } from "react-router-dom";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const cred = await createUserWithEmailAndPassword(auth, email, password);
      await setDoc(userDoc(cred.user.uid), {
        uid: cred.user.uid,
        email,
        createdAt: new Date().toISOString(),
      });
      setMessage("✅ Registered!");
      navigate("/dashboard");
    } catch (error) {
      setMessage("❌ " + error.message);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Register</h2>
      <form onSubmit={handleRegister} style={{display:"grid",gap:8,maxWidth:300}}>
        <input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button type="submit">Create account</button>
      </form>
      <p>{message}</p>
      <p>Already have an account? <Link to="/login">Login</Link></p>
    </div>
  );
}
